import axios from "axios";
import "./SingleUnit.css";
import SliderProject from "../../components/sliderProject/SliderProject";
import bac from "../../assats/bac.png";
import FormContactUs from "../../components/formCntactUs/FormContactUs";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { $ServerUrl } from "../../store";
import { useParams } from "react-router-dom";

export default function SingleUnit(props) {
  // const [serverUrl] = useRecoilState($ServerUrl);
  // const parms = useParams();
  // const unitId = parms.unitId;

  // function scrollToTop() {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth", // Smooth scrolling animation
  //   });
  // }
  // useEffect(() => {
  //   scrollToTop();
  //   let server = `${serverUrl}/units/${unitId}`;
  //   axios
  //     .get(server, {
  //       params: {
  //         populate: {
  //           unit_features: {
  //             populate: "*",
  //           },
  //         },
  //       },
  //     })
  //     .then((res) => {
  //       console.log(res.data.data);
  //       // setUnits(res.data.data.attributes.project_units.data);
  //     })
  //     .catch((err) => {
  //       // console.log(err);
  //     });
  // }, []);



  const [serverUrl] = useRecoilState($ServerUrl);
  const parms = useParams();
  const a = useParams()
  const unit = parms.unitId;
  console.log(unit)
  const [units, setunits] = useState({});

  function getunits() {
    let server = `${serverUrl}/units/${unit}`;
    axios
      .get(server, {
        params: {
          populate: {
            unit_features: {
              populate: "*",
            },
            unit_photos: {
              populate: "*",
            },
          },
        },
      })
      .then((res) => {
        console.log(res.data.data.attributes);
        setunits(res.data.data.attributes);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getunits();
    console.log(a)
  }, []);









  return (
    <>
      <div className="header-single-page container">
        <div className="left-header-unit-page">
          <h1 className="unit-title">{units.unit_name}</h1>
          <div className="control-units">
            <button className="btn-control-unit next">
              <i className="bi bi-arrow-left-circle-fill icon-arrow-previous"></i>
              الوحدة التالية
            </button>
            <button className="btn-control-unit previous">
              الوحدة السابقة
              <i className="bi bi-arrow-right-circle-fill icon-arrow-previous"></i>
            </button>
          </div>
        </div>
        <div className="right-header-unit-page">
          <h1 className="head-text-section-2">
            مشروع
            <span className="your-choose"> الريان </span>
          </h1>
          <p className="brief-short">
            بنفخر بتقديم تجربة عملاء راضين وشهادات نجاح ملهمة بتعكس جودة خدماتنا
            وتقديم حلول مبتكرة
          </p>
        </div>
      </div>
      <div className="container">
        <SliderProject
        //  imgs={null}
        imgs={units.unit_photos ? units.unit_photos : undefined}
          stylingSlider={true} />
      </div>
      <div className="brief-unit container">
        <div className="container-details-project container-details-unit">
          <h1 className="general-overview">نظرة عامة</h1>
          <div className="container-feoture display-card2">
            <p className="color-text2">{units.unit_price}</p>
            <p className="color-text2 head-price">السعر</p>
          </div>
          <div className="container-feoture display-card2">
            <p className="color-text2">{units.unit_area}م</p>
            <p className="color-text2 head-price">المساحات</p>
          </div>
          <div className="container-feoture display-card2">
            <p className="color-text2">{units.unit_rooms_no}</p>
            <p className="color-text2 head-price">الغرف</p>
          </div>
          <div className="container-feoture display-card2">
            <p className="color-text2">{units.unit_halls_no}</p>
            <p className="color-text2 head-price">الصالة </p>
          </div>
          <div className="container-feoture display-card2">
            <p className="color-text2">{units.unit_bathrooms_no}</p>
            <p className="color-text2 head-price">عدد دورات المياه</p>
          </div>
          <div className="container-feoture display-card2">
            <p className="color-text2">2</p>
            <p className="color-text2 head-price">مطبخ</p>
          </div>
          <hr className="container" />
          <h1 className="general-overview">المزايا</h1>
          {/* <div className="container-fioture"> */}







          {units.unit_features ? (
              <div className="container-features">
                {units.unit_features.data.map((feature , i) => {
                  return (
                    <div
                    key={i}
                      className="contaner-image-features"
                    >
                     
                      <img
                        className="col-12"
                        src={
                          serverUrl.includes("localhost")
                            ? serverUrl.split("/api")[0] +
                              feature.attributes.feature_icon.data.attributes
                                .url
                            : feature.attributes.feature_icon.data.attributes.url
                        }
                      />
                      
                  
                    </div>
                  );
                })}
              </div>
            ) : null}








          {/* </div> */}
        </div>
        <div className="desc-unit">
          <h1 className="general-overview">وصف</h1>
          <p className="brief-short color-text2">
            نحن نوفر خدمات الوساطة العقارية لعملائنا، خلال شراء العقار المناسب.
            ونحن نعمل على تسهيل عملية شراء العقارات بشكل سلس وسهل، وتوفير
            المشورة اللازمة لتحقيق أفضل قيمة للعملاءنحن نوفر خدمات الوساطة
            العقارية لعملائنا، خلال شراء العقار المناسب. ونحن نعمل على تسهيل
            عملية شراء العقارات بشكل سلس وسهل، وتوفير المشورة اللازمة لتحقيق
            أفضل قيمة للعملاءنحن نوفر خدمات الوساطة العقارية لعملائنا، خلال شراء
            العقار المناسب. ونحن نعمل على تسهيل عملية شراء العقارات بشكل سلس
            وسهل، وتوفير المشورة اللازمة لتحقيق أفضل قيمة للعملاء
          </p>
        </div>
      </div>

      <div className="container heading-form-unit-page">
        <h1 className="head-text-section-2">
          مشروع
          <span className="your-choose"> الريان </span>
        </h1>
        <p className="desc-heading-form-unit-page">
          بنفخر بتقديم تجربة عملاء راضين وشهادات نجاح ملهمة بتعكس جودة خدماتنا
          وتقديم حلول مبتكرة واقتصادية لتحقيق أعلى قيمة
        </p>
      </div>
      <div
        className="container-form-unit-page container"
        style={{ backgroundImage: `url(${bac})`, backgroundSize: "cover" }}
      >
        <FormContactUs
          stylingFontForm={true}
          styleInputs={true}
          stylebutton={true}
        />
      </div>
    </>
  );
}
